<div class="embed-container mb-5" id="vimeo-frame-{id}"></div>

<script>
import VimeoPlayer from "@vimeo/player";
import { createEventDispatcher, onMount } from "svelte";
const dispatch = createEventDispatcher();

export let videoUrl;

$: id = getVimeoId(videoUrl);

const initVimeoPlayer = () => {
  const player = new VimeoPlayer(`vimeo-frame-${id}`, {
    url: `https://player.vimeo.com/video/${id}`,
  });
  let played, dispatched;
  // TODO: does not work as expected
  // player.on("loaded", (data) => console.log("player loaded", data));
  player.on("error", (err) => console.error("player error", err));
  // player.on("play", () => console.log("play"));
  player.on("timeupdate", function (data) {
    if (!dispatched && !played && data.percent > 0.9) {
      console.log("90% played.");
      dispatch("videoPlayed");
      dispatched = true;
    }
  });
  // player.getVideoTitle().then(function (title) {
  //   console.log("video title:", title);
  // });
  window.playerinstance = player;
};

const getVimeoId = (url) => {
  if (!url) {
    return;
  }
  const regex = /.*([\d]{9,10}).*/;
  return url.match(regex).pop();
};

onMount(() => {
  setTimeout(initVimeoPlayer, 50);
});
</script>
